export default function authHeader() {
  let users = JSON.parse(localStorage.getItem('user'));

  if (users && users.accessToken) {
    return { Authorization: 'Bearer ' + users.access_token };
  } else {
    return {};
  }
}